module.exports = __webpack_public_path__ + "img/cooperative0_logo16.1e7b763b.jpg";